import { observer, useLocalObservable } from "mobx-react";
import { Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MyPageStore from "pages/MyPage/store/MyPageStore";

interface Props {
  pageStore: MyPageStore;
}

function MyPageScoreDetailTop(props: Props) {
  const { pageStore } = props;
  return (
    <Grid container justifyContent={'space-evenly'} gap={2} style={{ marginTop: '10px' }}>
      <Grid textAlign={'center'}>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '16px',
            color: '#171918',
          }}
        >
          {pageStore.last30dayCount}
        </Typography>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '14px',
            color: '#ABABAB',
            marginTop: '6px',
          }}
        >
          Last 30 days
        </Typography>
      </Grid>
      <Grid textAlign={'center'}>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '16px',
            color: '#171918',
          }}
        >
          {pageStore.quaterCount}
        </Typography>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '14px',
            color: '#ABABAB',
            marginTop: '6px',
          }}
        >
          Quarter
        </Typography>
      </Grid>
      <Grid textAlign={'center'}>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '16px',
            color: '#171918',
          }}
        >
          {pageStore.halfCount}
        </Typography>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '14px',
            color: '#ABABAB',
            marginTop: '6px',
          }}
        >
          Half-Year
        </Typography>
      </Grid>
      <Grid textAlign={'center'}>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '16px',
            color: '#171918',
          }}
        >
          {pageStore.yearCount}
        </Typography>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '14px',
            color: '#ABABAB',
            marginTop: '6px',
          }}
        >
          Full-Year
        </Typography>
      </Grid>
    </Grid>
  );
}

export default observer(MyPageScoreDetailTop);
